
import React from 'react';
import './Hero.css';
import HeroSlider from '../hero-slider/HeroSlider';

const Hero = () => {
  return (
    <div className='hero-sec'>
        <HeroSlider />
    </div>
  )
}

export default Hero;